import { render, staticRenderFns } from "./SparesBasket.vue?vue&type=template&id=235255d4"
import script from "./SparesBasket.vue?vue&type=script&lang=js"
export * from "./SparesBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports